import { ref, computed, watch } from '@vue/composition-api';

/**
 * Composition for base input. It tracks error and touched state of input
 * In some cases we don't want to show validation, especially required field validation
 * when user hasn't even touched the input. Thus the showErrors relies on the errors state and touched state.
 */
export default function (props, { root }) {
   const _touched = ref(false);
   const _errors = ref(props.errors);
   const _showErrors = computed(() => _touched.value && _errors.value && _errors.value.length);

   const touched = (value = null) => {
      if (value !== null) {
         _touched.value = value;
      }

      return _touched.value;
   }

   const errors = (value = null) => {
      if (value !== null) {
         _errors.value = value;
      }

      return _errors.value;
   }

   // ensure that _errors value is updated when error props is updated
   watch(() => props.errors, (newVal, oldVal) => {
      errors(newVal)
   });

   const showErrors = () => {
      return _showErrors.value
   }

   return {
      touched,
      errors,
      showErrors
   };
}

